import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './../../firebase';
import { useUser } from './../../contexts/UserContext.js';
import LoginPage from "./../../pages/LoginPage/LoginPage.jsx"

const AdminRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const { userData } = useUser();

  if (loading || (user && !userData)) {
    return <div>Loading...</div>;
  }

  return (userData && userData.isAdmin) ? children : (
    <div>
        Admin previliges required to view this page.
    </div>
  );
};

export default AdminRoute;